import { createAction, props } from '@ngrx/store';
import { ClubNote } from './club-notes.model';

// fetch all
export const fetchRecords = createAction(
    '[Data] fetch records club-note',
    props<{clubId: string}>()
);
export const fetchRecordsSuccess = createAction(
    '[Data] fetch records club-note success', 
    props<{ listData: ClubNote[], total: number }>()
);
export const fetchRecordsFail = createAction(
    '[Data] fetch records club-note failure', 
    props<{ error: string }>()
);

// fetch one 
export const fetchSingleRecord = createAction(
    '[Data] fetch single record club-note',
    props<{clubId: string, id: string}>()
);
export const fetchSingleRecordSuccess = createAction(
    '[Data] fetch single record club-note success', 
    props<{ singleData: ClubNote }>()
);
export const fetchSingleRecordFail = createAction(
    '[Data] fetch single record club-note failure', 
    props<{ error: string }>()
);

// Add Data
export const addRecord = createAction(
    '[Data] Add record club-note',
    props<{ clubId: string, newData: any }>()
);
export const addRecordSuccess = createAction(
    '[Data] Add record club-note success'
);
export const addRecordFailure = createAction(
    '[Data] Add record club-note failure',
    props<{ error: string }>()
);

// Update Data
export const updateRecord = createAction(
    '[Data] Update record club-note',
    props<{ clubId: string, id: string; updatedData: any }>()
);
export const updateRecordSuccess = createAction(
    '[Data] Update record club-note success'
);
export const updateRecordFailure = createAction(
    '[Data] Update record club-note failure',
    props<{ error: string }>()
);

// Delete Data
export const deleteRecord = createAction(
    '[Data] Delete record club-note',
    props<{ clubId: string, id: string }>()
);
export const deleteRecordSuccess = createAction(
    '[Data] Delete record club-note success'
);
export const deleteRecordFailure = createAction(
    '[Data] Delete record club-note failure',
    props<{ error: string }>()
);

//Reset State
export const resetState = createAction(
    '[Data] reset state club-note',
);